import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { IRootState } from "../types";
import { DrinkingState } from "./types";
import { initialDrinkingDay } from "@dcc/types/drinkingDay";

export const state: DrinkingState = {
  drinkFrequency: undefined,
  monthlyDrinkingDays: 0,
  drinkingDays: {},
  bingeFrequency: undefined,
  averageDrinkingDay: initialDrinkingDay,
  drinkFreeDays: [],
  targetPercentage: undefined
};

const namespaced: boolean = true;

export const namespace = "drinking";

export const drinking: Module<DrinkingState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
